export default function linear({ per_row, count, start, delay }) {
  const result = [];
  for (let i = 0; i < count; i++) {
    const row = Math.ceil(i / per_row);
    result.push({ offset: +start + row * delay, key: `key${i}` });
  }
  return result;
}
